/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Caixa} from '../../models/caixa'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";

const url = '/caixas'

const state = {
  all: [],
  allList: [],
  caixa: new Caixa(),
  filtro: new Filtro()
}

const getters = {
  listaAllCaixas: (state) => {
    return state.allList
  },

  listaCaixas: (state) => {
    return state.all
  },
  pegaCaixa: (state) => {
    return state.caixa
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['descr'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {caixas_id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('caixa_id', caixas_id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_CAIXA', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', BaseDescSCH(perPage))
  },

  async setAllListCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
    },
  async setAllCaixas({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_CAIXAS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarCaixa({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.caixa, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setCaixa({commit}, caixa) {
    commit('SET_CAIXA', caixa)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_CAIXAS(state, caixas) {
    state.all = caixas
  },
  SET_CAIXA(state, caixa) {
    state.caixa = caixa
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
